import { useState } from "react";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { timeComparison } from "../../../mocks/yokohamaData";

export default function TimeComparison() {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-10 md:mb-12">
              <p className="section-label mb-3">{timeComparison.label}</p>
              <h2 className="section-title">{timeComparison.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">{timeComparison.subtitle}</p>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={100}>
            <div className="flex justify-center mb-8 md:mb-10">
              <div className="inline-flex p-1 rounded-full bg-airdoa-cream">
                {timeComparison.items.map((item, idx) => (
                  <button
                    key={item.type}
                    onClick={() => setActiveTab(idx)}
                    className={`px-5 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${activeTab === idx ? "bg-airdoa-navy text-white" : "text-airdoa-gray hover:text-airdoa-navy"}`}
                  >
                    {item.title}
                  </button>
                ))}
              </div>
            </div>
          </ScrollReveal>

          {timeComparison.items.map((item, idx) => (
            <div
              key={item.type}
              className={`${activeTab === idx ? "block" : "hidden"}`}
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-center">
                <ScrollReveal direction="up" delay={150}>
                  <div className="overflow-hidden rounded-lg">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-60 md:h-80 object-cover object-top"
                    />
                  </div>
                </ScrollReveal>
                <ScrollReveal direction="up" delay={250}>
                  <div>
                    <h3 className="text-xl md:text-2xl font-serif font-semibold text-airdoa-navy mb-3">
                      {item.title}の楽しみ方
                    </h3>
                    <p className="text-sm md:text-base text-airdoa-gray leading-[1.9] mb-5">
                      {item.desc}
                    </p>
                    <div className="px-4 py-3 bg-airdoa-cream rounded-lg mb-4">
                      <p className="text-xs text-airdoa-gray mb-1">おすすめシーン</p>
                      <p className="text-sm font-medium text-airdoa-navy">{item.recommend}</p>
                    </div>
                    <div className="px-4 py-3 bg-airdoa-navy/5 rounded-lg">
                      <p className="text-xs text-airdoa-gray mb-1">料金目安</p>
                      <p className="text-sm font-medium text-airdoa-navy">{item.priceNote}</p>
                    </div>
                  </div>
                </ScrollReveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
